import { Meta } from 'components/Meta';
import { urlFor } from 'helpers/image';
import { getLocalizedUrl, prefixLocale } from 'helpers/url';
import { useRouter } from 'next/router';
import { Post } from 'types/schema';

type ArticleMetaProps = Pick<
  Post,
  'seoTitle' | 'title' | 'metaDescription' | 'blogPitch' | 'keywords' | 'mainImage'
>;

export const ArticleMeta = ({ data }: { data: ArticleMetaProps }) => {
  const router = useRouter();
  const imageUrl = data?.mainImage && urlFor(data.mainImage);
  return (
    <Meta
      title={data.seoTitle || data.title}
      description={data.metaDescription || data.blogPitch}
      keywords={data.keywords}
      image={imageUrl && imageUrl.width(1200).url()}
      opengraph={{
        type: 'article',
        url:
          prefixLocale(router.locale, router.defaultLocale) +
          getLocalizedUrl(router.route, router.locale, router.query),
      }}
    />
  );
};
